import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './secondary-button.css'

const SecondaryButton = ({ label, fluid, disabled, onClick }) => {
  const className = classNames({
    'secondary-button': !fluid,
    'secondary-button-fluid': fluid,
    'is-disabled': disabled,
  })

  return (
    <button styleName={className} onClick={disabled ? null : onClick}>
      {label}
    </button>
  )
}

SecondaryButton.propTypes = {
  disabled: PropTypes.bool,
  fluid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default CSSModules(SecondaryButton, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/secondary-button/secondary-button.js
 **/